import { KeyValueModel } from "model/api";
import { EnumTipoBuscaMapa } from "model/enums/enum-tipo-busca-mapa";

export const TipoBuscaMapaMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoBuscaMapa.Clientes, "Clientes"),
    new KeyValueModel(EnumTipoBuscaMapa.Revendedores, 'Revendedores')
];